import React, { Component } from 'react';
import {Link} from 'react-router-dom'
import {API_BASE_URL, SITE_NAME} from '../../constants'
import {getSessionPhone} from '../../storage'
import {CenterTitle} from '../header'
import axios from 'axios'

class ForgotpassOTP extends Component {


  constructor(props) {
    super(props)
    this.verifyOtp = this.verifyOtp.bind(this)
    this.handleInputChange = this.handleInputChange.bind(this)
    this.state = {otp:''}
    document.title = "Password recovery OTP- Goods Bill"
  }

  handleInputChange(e) {
    this.setState({
      [e.target.name]: e.target.value
    })
  }
  verifyOtp(e) {
    this.setState({error_response_data: undefined})
    e.preventDefault()
    axios({
      baseURL: API_BASE_URL,
      url:"/verify_forgot_pass_otp/",
      method:"POST",
      data: {otp:this.state.otp, phone: getSessionPhone()}
    }).then((response)=>{

      this.props.history.push('/update_password')
    }).catch(err=>{

      if(typeof err.response !== "undefined" && typeof err.response.data !== "undefined") {
        this.setState({error_response_data:err.response.data})
      }

    })
  }


  render() {

    let error_response_data = this.state.error_response_data
    let errors
    let otp_error
    if(typeof error_response_data !== "undefined") {
      errors = error_response_data.errors
      console.log(errors);
      if(typeof errors.otp !== "undefined" && errors.otp.length > 0) {
        otp_error = errors.otp[0]
      }
    }
    return (
      <div>

        <section>
          <div className="container">
              <div className="row">
                <div className="col-sm-6 col-sm-offset-3">
                  <div className="">
                      <CenterTitle />
                        <section className="small">
                        <h1 className="text-center">Forgot Password Verification</h1>
                        </section>
                        <form onSubmit={this.verifyOtp}>
                          <div className="form-group">
                            <small>Enter One Time Password(OTP)</small>
                            <small>An SMS has been sent to your phone</small>
                            <input type="text" name="otp" className="form-control" onChange={this.handleInputChange} />
                          </div>
                          <span className="text-danger">{otp_error}</span>
                          <div className="form-group">
                            <input type="submit" className="btn btn-primary btn-block" value="Submit" />
                          </div>

                        </form>

                  </div>
                </div>
              </div>
          </div>

        </section>
      </div>
    )
  }
}

export default ForgotpassOTP



// WEBPACK FOOTER //
// ./src/components/auth/forgotpassotp.js